import { Eye } from "lucide-react";
import React from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { Link } from "react-router-dom";

type ManageTagAssigneeActionIconProps = {
  id: number;
};

const ManageTagAssigneeActionIcon: React.FC<
  ManageTagAssigneeActionIconProps
> = ({ id }) => (
  <ActionIcon component={Link} to={`/employees/tags/${id}`}>
    <Tooltip label="Manage">
      <Eye size={18} />
    </Tooltip>
  </ActionIcon>
);

export default ManageTagAssigneeActionIcon;
